import { OPENAI_PIXEL_ID } from './marketingPixelConfig.js';

/**
 * @returns {((...args: unknown[]) => void) | undefined}
 */
function getOpenAiQueue() {
  const oaiq = window.oaiq;
  return typeof oaiq === 'function' ? oaiq : undefined;
}

/** OpenAI Ads page view (ChatGPT Ads measurement pixel). */
export function trackOpenAiPageViewed() {
  if (typeof window === 'undefined' || !OPENAI_PIXEL_ID) {
    return;
  }

  const oaiq = getOpenAiQueue();
  if (!oaiq) {
    return;
  }

  oaiq('measure', 'page_viewed', {
    type: 'contents',
  });
}
